var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageWrapDefault',{attrs:{"errorMessage":_vm.errorMessage,"successMessage":_vm.successMessage,"topActionButtonPrimary":_vm.$isCurrentUserAdmin || _vm.$isCurrentUserAgencyAdmin || _vm.$isCurrentUserSubAdmin
      ? {
          text: 'Create New',
          key: 'create'
        }
      : {},"topActionButtonSecondary":_vm.topButtonSecondaryItems},on:{"toolbarSelectItem":_vm.onToolbarItemClick,"errorMessageClosed":function($event){_vm.errorMessage = ''}}},[(!_vm.showUsersChart)?_c('ListUsersTable'):(_vm.showUsersChart)?_c('Charts',{attrs:{"exportChartData":false,"fitParent":['width'],"chart":_vm.chart,"allowFullScreen":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }